// components/Admin/UploadRankingsButton.jsx
import React from "react";
import { importLocationRankings } from "services/rankingService";

const UploadRankingsButton = ({ locationId }) => {
  const handleUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const text = await file.text();
    await importLocationRankings(locationId, text);
    alert("Classement importé avec succès !");
  };

  return (
    <>
      <label className="inline-block w-60 text-center cursor-pointer bg-blue-600 font-semibold text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
        Importer le classement
        <input
          type="file"
          accept=".csv"
          onChange={handleUpload}
          className="hidden"
        />
      </label>
    </>
  );
};

export default UploadRankingsButton;
